import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import colors from '../../colorPalette';
import ActionButton from './ActionButton';
const CellContent = styled.div ``;
const Wrapper = styled.tr `
  &:nth-child(even) {
    background-color: ${colors.black};
  }
  td {
    font-size: 14px;
    padding: 4px;
    text-align: left;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: ${colors.lightGrey};
    vertical-align: top;
    &.expandable {
      cursor: ${p => (p.$expanded ? 'n-resize' : 's-resize')};
    }
    ${CellContent} {
      white-space: ${p => (p.$expanded ? 'pre-wrap' : 'nowrap')};
      max-height: ${p => (p.$expanded ? 'none' : '25px')};
    }
    &:nth-child(2) {
      text-align: right;
      ${ActionButton} {
        margin-left: 8px;
      }
    }
  }
`;
const Textarea = styled.textarea `
  width: 100%;
  height: 300px;
  background-color: ${colors.darkGrey};
  color: ${colors.white};
  border-radius: 2px;
  border: 2px solid ${p => (p.$isValid ? colors.lightGrey : '#b34754')};
  outline: none;
`;
const Item = ({ item, columns, onEdit, onCancel, editMode: editModeProperty, onRemove, hasActions, }) => {
    const [expanded, setExpanded] = useState(false);
    const [editMode, setEditMode] = useState(editModeProperty);
    const [itemValue, setItemValue] = useState(() => JSON.stringify(item || {}));
    const [isValid, setIsValid] = useState(true);
    useEffect(() => {
        if (editMode)
            return;
        setItemValue(JSON.stringify(item || {}));
    }, [item, editMode]);
    return (_jsxs(Wrapper, { "$expanded": expanded, children: [editMode || !columns
                ? (_jsx("td", { title: editMode ? '' : itemValue, colSpan: columns ? columns.length : undefined, children: editMode
                        ? (_jsx(Textarea, { "$isValid": isValid, defaultValue: itemValue, onChange: (event) => {
                                const { value } = event.target;
                                setItemValue(value);
                                try {
                                    JSON.parse(value);
                                    setIsValid(true);
                                }
                                catch {
                                    setIsValid(false);
                                }
                            } }))
                        : itemValue }))
                : (_jsx(_Fragment, { children: columns.map(column => (_jsx("td", { className: "expandable", onClick: () => setExpanded(!expanded), children: _jsx(CellContent, { children: item?.[column.name] }) }, column.name))) })), hasActions && (_jsx("td", { children: editMode && onEdit
                    ? (_jsxs(_Fragment, { children: [_jsx(ActionButton, { disabled: !isValid, onClick: () => {
                                    try {
                                        const parsedItem = JSON.parse(itemValue);
                                        onEdit(parsedItem);
                                        setEditMode(false);
                                    }
                                    catch {
                                        setIsValid(false);
                                    }
                                }, children: "\u2705" }), _jsx(ActionButton, { onClick: () => {
                                    if (onCancel)
                                        onCancel();
                                    setEditMode(false);
                                }, children: "\u274C" })] }))
                    : (_jsxs(_Fragment, { children: [onEdit && (_jsx(ActionButton, { onClick: () => {
                                    setEditMode(true);
                                    setItemValue(JSON.stringify(item || {}, null, 2));
                                }, children: "\u270F\uFE0F" })), onRemove && _jsx(ActionButton, { onClick: onRemove, children: "\uD83D\uDDD1\uFE0F" })] })) }))] }));
};
export default Item;
